import "./Email.scss";
import { ReactComponent as Logo } from "./../../../assets/canguroLogo.svg";
import { ReactComponent as LogoText } from "./../../../assets/pickers.svg";
import { Form, Field } from "react-final-form";
import useValidationSchema from "hooks/useValidationSchema";
import { IEmailRestore } from "./types";
import { TextInput } from "@pickit/pickit-components";
import classNames from "classnames";
import "./i18n";
import { useTranslation } from "react-i18next";

export const EmailRestore = ({
  validationSchema,
  isFetching,
  testId,
  onSubmit,
}: IEmailRestore): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div className="background-login">
      <div className="login-logo-container">
        <Logo />
        <LogoText height={45} width={158} />
      </div>
      <Form
        onSubmit={onSubmit}
        validate={useValidationSchema(validationSchema)}
      >
        {({ invalid, handleSubmit }) => (
          <form className="login-form" onSubmit={handleSubmit}>
            <Field
              type="text"
              name="email"
              id="email"
              label={t("emailRestore:email")}
              className="email-restore-input"
              showClearIcon={false}
              component={TextInput}
              maxLength={50}
              testId={`${testId}-email`}
            />
            <button
              className={classNames("login-button email-button", {
                "button-disabled": invalid,
              })}
              disabled={isFetching || invalid}
              type="submit"
              name="button"
              data-testId={`${testId}-submit-button`}
            >
              <p
                className="login-init"
                data-testId={`${testId}-submit-button-label`}
              >
                {t("emailRestore:sendMail")}
              </p>
            </button>
          </form>
        )}
      </Form>
    </div>
  );
};
export default EmailRestore;
